import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FeatureRoutingModule } from './feature-routing.module';
import { HeroComponent } from 'src/app/feature/components/hero-section/hero/hero.component';
import { ScoreboardComponent } from './components/hero-section/scoreboard/scoreboard.component';
import { MainComponent } from './components/main/main.component';
import {SharedModule} from 'src/app/shared/shared.module';
import { SummaryComponent } from './components/hero-section/summary/summary.component';
import { ServicesComponent } from './components/services/services.component';
import { MediaComponent } from './components/media/media.component';
import { TutorialComponent } from './components/tutorial/tutorial.component';
import { ApplicationComponent } from './components/application/application.component';
import { NewLandingComponent } from './components/new-landing/new-landing.component';
import { FormsModule } from '@angular/forms';
import { OverlayModule } from '@angular/cdk/overlay';


@NgModule({
  declarations: [
    HeroComponent,
    ScoreboardComponent,
    MainComponent,
    SummaryComponent,
    ServicesComponent,
    MediaComponent,
    TutorialComponent,
    ApplicationComponent,
    NewLandingComponent,
  ],
  imports: [
    CommonModule,
    FeatureRoutingModule,
    SharedModule,
    FormsModule,
    OverlayModule
  ]
})
export class FeatureModule { }
